import BaseApi from './base';

class CotizacionesApi extends BaseApi {
  constructor() {
    super('cotizaciones');
  }

  getCotizacionByProceso(catServicioId, procesoId) {
    return this.request.get(`cotizaciones/${catServicioId}/${procesoId}`);
  }

  verificarCotizacionPagada(id) {
    return this.request.get(`cotizaciones/pagado/${id}`);
  }
}

export default new CotizacionesApi();
